/* eslint-disable react/prop-types */
// added the above text for the sonarqube fix

import React, { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";

import {
  Button,
  styled,
  MyTextInput,
  VisibilityIcon,
  VisibilityOffIcon,
  DialogActions,
  DialogContent,
  IconButton,
  InputAdornment,
  Typography,
} from "@common";

import { Dialog, } from "@mui/material";
export { styled } from "@mui/material/styles";

const PREFIX = 'MicrositeConfirmDialog';

const classes = {
  dialog: `${PREFIX}-dialog`,
  dialogTitle: `${PREFIX}-dialogTitle`,
  dialogContent: `${PREFIX}-dialogContent`,
  dialogAction: `${PREFIX}-dialogAction`,
  titleIcon: `${PREFIX}-titleIcon`
};

const StyledDialog = styled(Dialog)((
  {
    theme
  }
) => ({
  [`& .${classes.dialog}`]: {
    padding: theme.spacing(2),
    position: "absolute",
    top: theme.spacing(5),
  },

  [`& .${classes.dialogTitle}`]: {
    textAlign: "center",
  },

  [`& .${classes.dialogContent}`]: {
    textAlign: "center",
  },

  [`& .${classes.dialogAction}`]: {
    justifyContent: "center",
  },

  [`& .${classes.titleIcon}`]: {
    backgroundColor: theme.palette.grey.light,
    color: theme.palette.grey.main,
    "&:hover": {
      backgroundColor: theme.palette.grey.light,
      cursor: "default",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "8rem",
    },
  }
}));

// --------------------------------------------------------------------------------

const validationSchema = Yup.object().shape({
  password: Yup.string()
    .required("Password is required")
    .test("noEmptySpaces", " Field cannot be only empty spaces", function (value) {
      return value === undefined || value.trim().length > 0;
    }),
  //   .max(50, "Organization Name Should not Exceed More Than 50 Charecters")
  //   .matches(textChecker, textFieldErr),
});

//   -------------------------------------------------------------------------------

const MicrositeConfirmDialog = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const formik = useFormik({
    initialValues: {
      password: "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      confirmDialog.onConfirm(values?.password, formik?.resetForm);
    },
  });

  const { confirmDialog } = props;



  return (
    <StyledDialog open={confirmDialog.isOpen} classes={{ paper: classes.dialog }}>
      <DialogContent className={classes.dialogContent}>
        <Typography variant="h6">{confirmDialog.title}</Typography>
        <Typography variant="subtitle2">{confirmDialog.subTitle}</Typography>
        <MyTextInput
          label="Login Password"
          type={showPassword ? "text" : "password"}
          name="password"
          required={true}
          fullWidth={true}
          margin="normal"
          id="password"
          // onChange={(e) => setPassword(e.target.value)}
          onChange={formik.handleChange}
          // onBlur={formik.handleBlur}
          autoFocus
          error={formik.touched.password && Boolean(formik.errors.password)}
          helperText={formik.touched.password && formik.errors.password}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end">
                  {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon /> }
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </DialogContent>
      <DialogActions className={classes.dialogAction} sx={{ justifyContent: "center" }}>
        <Button
          inputProps={{ tabIndex: "1" }}
          variant="contained"
          color="primary"
          onClick={() => {
            props.setConfirmDialog({ isOpen: false });
            formik.resetForm();
          }}>
          No
        </Button>

        <Button
          variant="contained"
          color="red"
          // onClick={password ? () => confirmDialog.onConfirm(password, setPassword) : null}
          onClick={formik.handleSubmit}>
          Yes
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default MicrositeConfirmDialog;
